import React from "react";
import theme from "../../styles/theme";
import { WizardHatIcon } from "../common/Brand";

const T = theme.colors;

export default function Footer() {
  return (
    <footer style={{ borderTop: `1px solid ${T.border}40`, padding: "32px 24px", textAlign: "center" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 12 }}>
        <WizardHatIcon size={20} color={T.purple} />
        <span style={{ fontSize: 14, fontWeight: 700, color: T.textMuted }}>
          WYZCON <span style={{ fontWeight: 400, color: T.textDim }}>Intelligence</span>
        </span>
      </div>
      <p style={{ fontSize: 12, color: T.textDim, fontFamily: theme.fonts.mono, maxWidth: 500, margin: "0 auto" }}>
        Infrastructure Research Intelligence for Educators
        <br />Built by teachers, for teachers. Open data. No agenda.
      </p>
      <div style={{ marginTop: 16, fontSize: 11, color: T.textDim }}>
        &copy; 2025 Wyzcon &middot;{" "}
        <span style={{ color: T.violet, cursor: "pointer" }}>About</span> &middot;{" "}
        <span style={{ color: T.violet, cursor: "pointer" }}>Privacy</span> &middot;{" "}
        <span style={{ color: T.violet, cursor: "pointer" }}>Terms</span>
      </div>
    </footer>
  );
}
